export const SNACKBAR_DURATION = 3000;
export const SUCCESS = 'success';
